import { Constants } from "../../../contants";
import {
  INTIATE_VIEW_INTRODUCTION_DATA,
  SET_VIEW_INTRODUCTION_DATA,
  SET_VIEW_INTRODUCTION_DATA_FAIL,
  SET_SELECTED_INTRODUCTION,
  INITIATE_VIEW_INTRODUCTION_REMARKS_DATA,
  SET_VIEW_INTRODUCTION_REMARKS_DATA,
  SET_VIEW_INTRODUCTION_REMARKS_DATA_FAIL,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
  selectedIntroduction: {
    remarks: {
      data: [],
      isLoading: false,
      error: null,
    },
  },
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INTIATE_VIEW_INTRODUCTION_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_VIEW_INTRODUCTION_DATA:
      return {
        ...state,
        data: payload.data,
        isLoading: false,
        paginationInfo: payload?.paginationInfo,
      };
    case SET_VIEW_INTRODUCTION_DATA_FAIL:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: payload,
      };

    case SET_SELECTED_INTRODUCTION:
      return {
        ...state,
        selectedIntroduction: {
          ...state.selectedIntroduction,
          ...payload,
        },
      };

    case INITIATE_VIEW_INTRODUCTION_REMARKS_DATA:
      return {
        ...state,
        selectedIntroduction: {
          ...state.selectedIntroduction,
          remarks: {
            isLoading: true,
            data: [],
            error: null,
          },
        },
      };

    case SET_VIEW_INTRODUCTION_REMARKS_DATA:
      return {
        ...state,
        selectedIntroduction: {
          ...state.selectedIntroduction,
          remarks: {
            data: payload,
            isLoading: false,
            error: null,
          },
        },
      };

    case SET_VIEW_INTRODUCTION_REMARKS_DATA_FAIL:
      return {
        ...state,
        selectedIntroduction: {
          ...state.selectedIntroduction,
          remarks: {
            isLoading: false,
            data: [],
            error: payload,
          },
        },
      };

    default:
      return { ...state };
  }
};

export default reducer;
